import axios from "axios";
import * as actionType from "../../../constant/actionType";

export const GenerateProviderOverviewReport = (apiData) => async (dispatch) => {
  try {
    const response = await axios({
      method: "get", // Change GET to POST
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        "Content-Type": "application/json",
      },
      url: `${actionType.environment_url}/api/admin/provider/GenerateProviderOverviewReport`,
      params: {
        ...apiData,
        status: apiData.status.replace(/\s+/g, "_"),
        client_org_ids: JSON.stringify(apiData.client_org_ids),
        provider_org_ids: JSON.stringify(
          apiData.provider_org_ids?.map((item) => item?.provider_org_id)
        ),
        provider_type_ids: JSON.stringify(apiData.provider_type_ids),
      },
    });

    return response.data;
  } catch (error) {
    return error.message;
  }
};
